import { TaInput } from '@components/shared';
import { GeneralMuiModal } from '@components/shared/general-mui-modal';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface PaymentCardProps {
	open: boolean;
	onClose: () => void;
}

export const PaymentCard: React.FC<PaymentCardProps> = ({ open, onClose }) => {
	const { t } = useTranslation();

	const actions = (
		<div className="w-full flex justify-between border-t border-gray-300 pt-[10px]">
			<Button
				variant="contained"
				onClick={onClose}
				className="mr-2 !bg-white !shadow-custom-button py-[10px] pr-[20px] !pl-[10px]"
			>
				<KeyboardArrowLeftIcon sx={{ color: '#7B809A' }} />
				<span className="text-dark"> {t('previous')}</span>
			</Button>
			<Button className="!pr-[10px]" variant="contained" color="primary">
				{t('sendOffer')}
				<KeyboardArrowRightIcon />
			</Button>
		</div>
	);

	return (
		<GeneralMuiModal
			open={open}
			onClose={onClose}
			title={t('sendAnOffer')}
			styles={{
				paperStyle: { width: '500px' },
			}}
			content={
				<div className="flex flex-col gap-[20px] pb-5 mt-[20px]">
					<span className="roboto-regular text-[16px] leading-[140%] text-secondary">
						{t('makePaymentSure')}
					</span>
					<TaInput id={'socialLinks'} label={t('IBAN')} size={'small'} />
					<TaInput id={'Swift'} label={t('Swift')} size={'small'} />
					<TaInput id={'ReceiverFullName'} label={t('ReceiverFullName')} size={'small'} />
				</div>
			}
			actions={actions}
		/>
	);
};
